import { useMemo } from 'react'

import { theme } from '@ui/theme'

import useMetaTag from '@odyssey/hooks/useMetaTag/useMetaTag'
import useThemeCSSVarComputedValues from '@odyssey/hooks/useThemeCSSVarComputedValues/useThemeCSSVarComputedValues'

/**
 * Maintains a `<meta name="theme-color">` tag in the document `<head>` based
 * on the app's current theme.
 */
export default function useMetaThemeColor() {
  // eslint-disable-next-line custom-rules/no-memoization-in-odyssey -- it needs to be referentially stable otherwise it will indefinitely setState
  const variables = useMemo(
    // eslint-disable-next-line custom-rules/theme-palette-token -- the raw var name is needed
    () => ({ sideMenu: theme.palette.background.sideMenu }),
    [],
  )
  const { sideMenu } = useThemeCSSVarComputedValues(variables)
  useMetaTag('theme-color', sideMenu)
}
